<!-- Full-screen lock — covers ALL app content while biometric is required. -->
<div class="fixed inset-0 z-[9999] bg-[#F7FAF8] dark:bg-night-bg
            text-ink dark:text-night-text font-sans antialiased
            flex flex-col items-center justify-center px-8 safe-x safe-bottom">

  <!-- Brand -->
  <app-brand-mark size="xl" />

  <!-- Biometric prompt area -->
  <div class="mt-12 flex flex-col items-center gap-4 max-w-sm w-full">
    <div class="h-20 w-20 rounded-full bg-green-pale dark:bg-night-raised flex items-center justify-center text-green dark:text-green-light shadow-sm">
      @if (authenticating()) {
        <i class="pi pi-spin pi-spinner text-3xl"></i>
      } @else {
        <i class="pi pi-lock text-3xl"></i>
      }
    </div>

    <p class="mt-2 text-base font-semibold text-ink dark:text-night-text text-center">
      Sign in with {{ biometryLabel() }}
    </p>
    <p class="text-sm text-ink-mid dark:text-night-mid text-center">
      EmitRoll is locked. Verify with biometrics to continue.
    </p>

    @if (errorMessage(); as err) {
      <p class="text-xs text-red-600 dark:text-red-400 text-center max-w-xs">{{ err }}</p>
    }
  </div>

  <!-- Actions -->
  <div class="mt-10 max-w-sm w-full space-y-3">
    <button type="button"
            (click)="tryUnlock()"
            [disabled]="authenticating()"
            class="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full
                   bg-green hover:bg-green-light dark:bg-green-light dark:hover:bg-green-glow
                   text-white text-sm font-bold shadow-sm
                   disabled:opacity-60 disabled:cursor-not-allowed transition-colors">
      <i class="pi pi-shield"></i>
      Unlock
    </button>
    <button type="button"
            (click)="usePassword()"
            class="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full
                   border border-line dark:border-line-dark
                   text-ink dark:text-night-text text-sm font-semibold
                   hover:border-green dark:hover:border-green-light transition-colors">
      Use password instead
    </button>
  </div>
</div>
